import { FunctionComponent } from "react";

import AccelerateContent from "./AccelerateContent";
import ElevateBoardContent from "./ElevateBoardContent";
import ElevateContent from "./ElevateContent";
import FulfilYourAmbitionContent from "./FulfilYourAmbitionContent";
import AccelerateLearnerQuote from "./AccelerateLearnerQuote";
import ElevateLearnerQuote from "./ElevateLearnerQuote";
import CtaStrip from "../../CtaStrip";
import WooboxQuizContent from "../../WooboxQuizContent";

const MainProgrammesContent: FunctionComponent = () => {
  return (
    <>
      <FulfilYourAmbitionContent />
      <AccelerateContent />
      <AccelerateLearnerQuote />
      <WooboxQuizContent type="membership" />
      <ElevateContent />
      <ElevateLearnerQuote />
      <ElevateBoardContent />
      <CtaStrip
        copy="Ready to begin?"
        linkText="Become a Learner"
        linkUrl={"/memberships"}
      />
    </>
  );
};

export default MainProgrammesContent;
